let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hC8hF")).then(() => parcelRequire('8vWFf'));